import { tv } from 'tailwind-variants';

export const formStyle = tv({
  slots: {
    inputSection: `
        space-y-4
      `,
    inputSectionTitle: `
        flex
        items-center
        gap-3
        text-lg
        font-medium
        text-gray-800
      `,
    inputSectionRow: `
        grid
        grid-cols-2
        gap-6
      `,
    input: `
        ring-neutral-200
        hover:ring-neutral-300
      `,
    inputUnits: `
        text-xs
        text-zinc-400
      `,
    label: `
        mb-2
        flex
        items-center
        gap-1
        text-sm
        font-medium
        text-gray-700
      `,
    labelNote: `
      ml-0.5
      text-xs
      font-normal
      text-gray-400
      `,
    button: `
      !px-4
      !py-3
      text-base
      `,
  },
});
